// extracted by mini-css-extract-plugin
export var companyLine = "Footer-module--company-line--1cb4a";
export var container = "Footer-module--container--70893";
export var content = "Footer-module--content--03575";
export var copyright = "Footer-module--copyright--a775b";
export var footer = "Footer-module--footer--2d913";
export var logo = "Footer-module--logo--2eef9";
export var menuContainer = "Footer-module--menu-container--7ce1f";
export var phoneNumbers = "Footer-module--phone-numbers--7e08a";